import React from 'react';

const About = () => {
  return (
    <div className="page-content page-top">
      <div className="container-medium">
          <div className="page-header">
            <h1 className="page-title">About Us</h1>
            <p className="page-subtitle">
              We're building the future of e-commerce management for TikTok Shop sellers.
            </p>
          </div>

          <div className="content-card">
            <h2 className="section-title">Our Mission</h2>
            <p className="text-content">
              We empower TikTok Shop sellers to focus on what they do best—creating amazing products and
              building their brand. Our platform handles the complex logistics of order management, inventory
              tracking, and data analytics so you can scale your business without the operational headaches.
            </p>
            <p className="text-content">
              Founded by e-commerce veterans who understand the challenges of selling on social platforms,
              we've built a solution that combines powerful automation with intuitive design. Whether you're
              managing dozens or thousands of orders daily, our tools adapt to your needs.
            </p>
          </div>

          <div className="info-grid">
            <div className="info-card">
              <div className="info-number">2020</div>
              <div className="info-label">Founded</div>
            </div>
            <div className="info-card">
              <div className="info-number">1,000+</div>
              <div className="info-label">Active Sellers</div>
            </div>
            <div className="info-card">
              <div className="info-number">50+</div>
              <div className="info-label">Team Members</div>
            </div>
          </div>

          <div className="values-card">
            <h2 className="section-title-white">Our Values</h2>
            <div className="values-grid">
              <div className="value-item">
                <h3>Innovation First</h3>
                <p>We continuously evolve our platform with the latest technology to stay ahead of market
                  needs.</p>
              </div>
              <div className="value-item">
                <h3>Customer Success</h3>
                <p>Your growth is our success. We're committed to providing exceptional support and
                  tools.</p>
              </div>
              <div className="value-item">
                <h3>Reliability</h3>
                <p>99.9% uptime and enterprise-grade security ensure your business never misses a beat.</p>
              </div>
              <div className="value-item">
                <h3>Transparency</h3>
                <p>Clear pricing, honest communication, and no hidden fees. What you see is what you
                  get.</p>
              </div>
            </div>
          </div>
      </div>
    </div>
  );
};

export default About;
